const theme = {
  colors: {
    primary: '#0D9488',
    primaryDark: '#0F766E',
    primaryLight: '#CCFBF1',
    secondary: '#EA580C',
    secondaryDark: '#C2410C',
    secondaryLight: '#FFEDD5',
    background: '#F8FAFC',
    surface: '#FFFFFF',
    text: '#0F172A',
    textLight: '#64748B',
    textSecondary: '#64748B',
    border: '#E2E8F0',
    borderDark: '#CBD5E1',
    error: '#EF4444',
    errorDark: '#DC2626',
    errorLight: '#FEE2E2',
    warning: '#F59E0B',
    warningDark: '#D97706',
    warningLight: '#FEF3C7',
    success: '#10B981',
    successDark: '#059669',
    successLight: '#D1FAE5',
    info: '#0284C7',
    infoDark: '#0369A1',
    infoLight: '#E0F2FE',
    danger: '#EF4444',
    dangerDark: '#DC2626',
    dangerLight: '#FEE2E2',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
  },
  gradient: '#0F766E',
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1200px',
  },
  typography: {
    fontSizes: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
    },
    fontWeights: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
};

export default theme; 